import { createContext, useState } from "react";

export const IntegracoesContext = createContext();

export const IntegracoesProvider = ({ children }) => {
    const [integrations, setIntegrations] = useState([]); // Estado que armazena a lista de Integrações
    const [leads, setLeads] = useState([]); // Estado que armazena a lista de Leads
    const [integrationSearched, setIntegrationSearched] = useState(""); // Estado que armazena o texto da Busca
    const [isOpenModalCreateIntegration, setIsOpenModalCreateIntegration] = useState(false);
    const [formDataModalCreateIntegration, setFormDataModalCreateIntegration] = useState(null); // Estado que armazena se Integração deve ser criada
    const [isOpenModalDeleteIntegration, setIsOpenModalDeleteIntegration] = useState(false);
    const [formDataModalDeleteIntegration, setFormDataModalDeleteIntegration] = useState(null); // Estado que armazena se Integração deve ser deletada
    const [isOpenModalIntegration, setIsOpenModalIntegration] = useState(false);
    const [formDataModalIntegration, setFormDataModalIntegration] = useState(null); // Estado que armazena os dados da Integração para visualização ou edição
    const [itemsPerPage, setItemsPerPage] = useState(10); // Estado que armazena a quantidade de Itens por Página
    const [currentPage, setCurrentPage] = useState(1); // Estado que armazena qual é a Página Atual que está sendo apresentada



    return (
        <IntegracoesContext.Provider
            value={{
                integrations, setIntegrations, integrationSearched, setIntegrationSearched, isOpenModalCreateIntegration, setIsOpenModalCreateIntegration, formDataModalCreateIntegration, setFormDataModalCreateIntegration,
                isOpenModalDeleteIntegration, setIsOpenModalDeleteIntegration, formDataModalDeleteIntegration, setFormDataModalDeleteIntegration, itemsPerPage, setItemsPerPage, currentPage, setCurrentPage,
                isOpenModalIntegration, setIsOpenModalIntegration, formDataModalIntegration, setFormDataModalIntegration, leads, setLeads
            }}>
            {children}
        </IntegracoesContext.Provider>
    );
};
